import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  private onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private ngZone: NgZone) {
    window.addEventListener('online', () => this.updateNetworkStatus(true));
    window.addEventListener('offline', () => this.updateNetworkStatus(false));
  }

  private updateNetworkStatus(status: boolean): void {
    this.ngZone.run(() => this.onlineStatus.next(status));
  }

  getNetworkStatus(): Observable<boolean> {
    return this.onlineStatus.asObservable();
  }
}
